import Container from 'components/Container'
import { MDXLayoutRenderer } from 'components/MDXComponents'
import { allOtherPages, OtherPage } from 'contentlayer/generated'
import { getTweets } from 'lib/twitter'
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from 'next'
import { Tweet } from 'types/Twitter'

export const getStaticProps: GetStaticProps<{
  pageData: OtherPage
  tweets?: Tweet[]
}> = async ({ params }) => {
  const pageData = allOtherPages.find((page) => page.slug === `/${params.page}`)

  if (!pageData) {
    return {
      notFound: true,
    }
  }

  const tweets = await getTweets(pageData.tweetIds || [])

  return {
    props: {
      pageData,
      tweets,
    },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = allOtherPages.map((page) => page.slug)
  return {
    paths,
    fallback: false,
  }
}

export default function OtherPages({
  pageData,
  tweets,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Container>
      <MDXLayoutRenderer
        content={pageData}
        layout={pageData.layout}
        tweets={tweets}
        {...pageData}
      />
    </Container>
  )
}
